import React, { useEffect, useRef } from 'react';
import { TabContent, TabPane, NavLink, Nav, NavItem } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiWaves, mdiPencilRulerOutline, mdiChevronLeft, mdiChevronRight, mdiExitToApp } from '@mdi/js';
import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu';
import { WDTContent } from './WDTContentComp/WDTContent';
import { WDTContainerVM } from './WDTContainerVM';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { SummaryComp } from './WDTContentComp/Summary/Summary';
import { useHistory } from 'react-router-dom';
import { Popup } from 'cd-eft/components/common/Popup';
import { LoaderWithBar } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import './WDTContainer.scss';
import { WaterwayTypeComp } from './WDTContentComp/WaterwayType/WaterwayType';
const { waterwayDesignStore, designStore } = stores.AppStore;

interface IWdtProps {
  title: string;
  addWDTEdits: any;
  saveReachEdits: any;
  resetPEMReachEdits: any;
  retriveFlowCalculationResults: any;

  clearAiTrainingEdits?: () => void
}

const WDTContainerComponent = (props: IWdtProps) => {
  const history = useHistory();
  const vm = useRef(new WDTContainerVM(history)).current;

  useEffect(() => {
    if (!stores.AppStore.waterwayDesignStore.alignedDesignElementId) {
      waterwayDesignStore.currentWorkflowStep = 'waterway-input';
    }
  }, [stores.AppStore.designStore.projectsStore.currentSessionId, stores.AppStore.waterwayDesignStore.alignedDesignElementId]);

  useEffect(() => {
    vm.init();
  }, []);

  useEffect(function mount() {
    function unmount() {
      waterwayDesignStore.reset();
    }
    return unmount;
  }, []);

  return (
    <>
      <WDTLoaderContainer />
      <CollapseMenu
        title={!vm.addWaterwayClicked ? "Waterway Design Summary" : vm.stepToTitle}
        noIcon={true}
        forceOpen={true}
        className={`designelement-container ${vm.addWaterwayClicked ? 'container-with-sidebar' : 'wdt-summary-container'}`}>
        {waterwayDesignStore.saveWaterwayTypePage &&
          <WaterwayTypeComp
            saveWaterwayOnSelectWaterwayTypePage={vm.saveWaterwayOnSelectWaterwayTypePage}
            handleOnClickCloseButtonOnSelectWaterwayTypePage={vm.handleOnClickCloseButtonOnSelectWaterwayTypePage} />
        }

        {!vm.addWaterwayClicked && !waterwayDesignStore.saveWaterwayTypePage &&
          <SummaryComp
            onClickEdit={vm.onClickEdit}
            onClickAddButtonOnSummaryPage={vm.onClickAddButtonOnSummaryPage} />
        }
        {vm.addWaterwayClicked && !waterwayDesignStore.saveWaterwayTypePage &&
          <div className="WDTContainer">
            <nav className={`wdt-navbar ${vm.isCollapsed ? '' : 'collapsed'}`} id="sidebarWDT" aria-label="Waterway Menu">
              <Nav vertical>
                <NavItem className="tab-item" key="waterway-input">
                  <NavLink
                    tag="button"
                    data-testid="waterway-input"
                    className={`baseTab ${waterwayDesignStore.currentWorkflowStep === 'waterway-input' ? 'active' : ''}`}
                    onClick={() => vm.changeTab('waterway-input')}
                  >
                    <Icon path={mdiWaves} title="Waterway Inputs" size={1.2} />
                    {vm.isCollapsed ? <div>Waterway Inputs</div> : null}
                  </NavLink>
                </NavItem>

                <NavItem className="tab-item" key="design-waterway">
                  <NavLink
                    tag="button"
                    data-testid="design-waterway"
                    className={`baseTab ${waterwayDesignStore.currentWorkflowStep === 'design-waterway' ? 'active' : ''}`}
                    onClick={() => vm.changeTab('design-waterway')}
                  >
                    <Icon path={mdiPencilRulerOutline} title="Waterway Design" size={1.2} />
                    {vm.isCollapsed ? <div>Waterway Design</div> : null}
                  </NavLink>
                </NavItem>
                <NavItem className="tab-item" key='collapse-button'>
                  <NavLink
                    tag="button"
                    className="collapse-menu-2"
                    onClick={vm.toggleCollapsed}
                  >
                    {vm.isCollapsed ? (
                      <>
                        <Icon className="icon" path={mdiChevronLeft} size={1.2} color="#ffffff" /><br />
                        Collapse Sidebar
                      </>
                    ) : (
                      <Icon className="icon" path={mdiChevronRight} size={1.2} color="#ffffff" />
                    )}
                  </NavLink>
                </NavItem>
              </Nav>
            </nav>
            <div className="wdt-content" id="WDT-content">
              <TabContent className="h-100" activeTab={waterwayDesignStore.currentWorkflowStep}>
                <TabPane className="tab-pane-input h-100" tabId={'waterway-input'}>
                  <WDTContent
                    title="Waterway Inputs"
                    sideNav={vm.isCollapsed}
                    toggleAddWaterwayClicked={vm.toggleAddWaterwayClicked}
                    retriveFlowCalculationResults={props.retriveFlowCalculationResults}
                    getNotificationStatus={vm.getNotificationStatus}
                    getDesignUiState={vm.getDesignUiState}
                    getWDTContainerDataOnMount={vm.getAllDataOnMount}
                  />
                </TabPane>
                <TabPane className="tab-pane-design h-100" tabId={'design-waterway'}>
                  {waterwayDesignStore.renderWaterwayDesign === true && (
                    <WDTContent
                      title="Waterway Design"
                      sideNav={vm.isCollapsed}
                      addWDTEdits={props.addWDTEdits}
                      saveReachEdits={props.saveReachEdits}
                      resetPEMReachEdits={props.resetPEMReachEdits}
                      toggleAddWaterwayClicked={vm.toggleAddWaterwayClicked}
                      getNotificationStatus={vm.getNotificationStatus}
                      getDesignUiState={vm.getDesignUiState}
                      clearAiTrainingEdits={props.clearAiTrainingEdits}
                    />
                  )}
                </TabPane>
              </TabContent>
            </div>
          </div>
        }
      </CollapseMenu>

      {vm.leavingWarningDialogIsOpen && (
        <Popup
          trigger={vm.leavingWarningDialogIsOpen}
          setTrigger={vm.toggleLeavingWarningDialog}
          title={waterwayDesignStore.currentWorkflowStep === 'waterway-input' ? 'Leaving Waterway Inputs?' : 'Leaving Waterway Design?'}
          icon={mdiExitToApp}
          handleCancel={vm.toggleLeavingWarningDialog}
          cancelText="Return"
        >
          <p>{waterwayDesignStore.notifications.unsavedEdits}</p>
        </Popup>
      )}
    </>
  );
};

export const WDTContainer = observer(WDTContainerComponent);

const WDTLoaderContainer = observer(() => {
  return (
    <>
      {designStore.isLoading && (
        <LoaderWithBar
          message={designStore.loadingMsg}
          className={'design-container-loader'}
          processName={designStore.processName}
          loadingProgress={designStore.loadingProgress}
          loading={designStore.isLoading}
        />
      )}
    </>
  );
});
